var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 283.47,
    height: 112.48,
    viewBox: "0 0 283.47 112.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.119,
    y1: -0.156,
    x2: 0.881,
    y2: 0.844,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2007a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#c7007b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#a8007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8f137e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#7f1a7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791c7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.156,
    y1: 0.881,
    x2: 0.844,
    y2: 0.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b3087"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.156,
    y1: 0.881,
    x2: 1.156,
    y2: 0.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#791c7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#7f1a7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#8f137e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#a7007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#c6007b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2007a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.119,
    y1: 0.156,
    x2: 0.881,
    y2: 1.157,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a9d8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spbavecbaseline-couleur-HD",
    transform: "translate(-13.47 -29.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SPB_00000163795895695033051080000010383254653107901312_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M271.22,58.1a32.916,32.916,0,0,0-13.58,2.64V29.98H241.66v81.84s15.75,4.09,25.84,4.09,29.44-4.33,29.44-28.48S279.51,58.1,271.22,58.1Zm-3.25,45.07c-7.21,0-10.57-1.68-10.57-1.68V73.72a21.106,21.106,0,0,1,10.93-3c6.49,0,12.74,6.37,12.74,16.34S275.18,103.17,267.97,103.17Z",
    fill: "#3e3d40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M211.58,56.9c-14.29,0-17.67,9.97-17.67,9.97.12-12.86-18.03-8.89-18.03-8.89V69.03c5.53-.96,5.05,3.49,5.05,3.49l.1,69.94h15.89V111.7s2.88,3.24,12.86,3.24c14.06,0,26.56-11.77,26.56-28.96S225.87,56.9,211.58,56.9Zm-3.25,44.34c-9.21,0-11.9-3.36-11.9-3.36V81.66s.25-10.94,11.9-10.94,11.89,12.98,11.89,15.26C220.22,92.66,217.21,101.24,208.33,101.24Z",
    fill: "#3e3d40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M156.54,74.69h15.03s.72-17.79-23.68-17.79-24.15,14.9-24.15,18.51,1.2,13.07,17.42,15.14c13.55,1.73,16.27,2.52,16.35,6.61.07,3.84-3.13,6.61-9.02,6.61s-9.37-1.92-9.73-6.49l-15.86.12s-1.68,18.14,25.72,18.14c26.32,0,24.77-17.19,24.77-18.27s.32-14.03-16-15.99c-17.01-2.03-18.03-2.88-18.03-6.61s4.38-5.65,8.8-5.65C152.57,69.04,156.42,71.32,156.54,74.69Z",
    fill: "#3e3d40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M70.66,42.67H43.41L86.97,86.24l13.64-13.62Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M43.41,42.67h0L13.47,72.62V99.84L27.1,86.24,57.03,56.3Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M86.97,86.24,57.03,116.17l13.63,13.62,29.95-29.95V72.62Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M57.03,116.17,27.1,86.24,13.47,99.84l29.94,29.95H70.66Z",
    fill: "url(#linear-gradient-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7982bd5c28b241c966d486ba6b718cc0.svg";
export { ForwardRef as ReactComponent };